// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__sdno5"};